import React, { useEffect } from 'react';
import { useParams } from 'react-router-dom';

import Buscando from 'Component/Admin/Buscando';
import Cabecalho from 'Component/Admin/Cabecalho';
import { useRecuperarTarefaQuery } from 'View/Service/Default/Tarefas';

import ProducaoDeUA from './ProducaoDeUA';
import UploadDeVideosParaUA from './UploadDeVideosParaUA';

const Editar = (): React.ReactElement => {
  const { id = 0 } = useParams();

  const { data: { tarefa } = {}, refetch } = useRecuperarTarefaQuery({
    id,
    contain: ['Proprietarios', 'Atendentes'],
    scope: false,
  });

  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(() => refetch(), []);

  const selecionarTipo = (): JSX.Element => {
    switch (tarefa?.tipo) {
      case 'producao-de-ua':
        return <ProducaoDeUA tarefa={tarefa} />;
      case 'upload-de-videos-para-ua':
        return <UploadDeVideosParaUA tarefa={tarefa} />;
    }

    return <Buscando exibir={true} />;
  };

  return (
    <div className="animate__animated animate__fadeIn">
      <Cabecalho
        titulo={`Tarefa #${tarefa?.id}`}
        descricao={tarefa?.titulo || 'Carregando'}
      />
      {selecionarTipo()}
    </div>
  );
};

export default Editar;
